import ActionTypes from "./types";
import vehicletypeAPIHelper from "../../helpers/api/vehicletypeAPIHelper";

/**
 * Get list for Vehicle Type
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function getList(token, successCallback = null, failCallback = null) {
  return (dispatch) => {
    vehicletypeAPIHelper.getList(
      token,
      (response) => {
        const {
          responseDetail: { data },
        } = response;
        dispatch({
          type: ActionTypes.VEHICLE_TYPE_GET_LIST,
          data,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

/**
 * Select the vehicle type for form input
 * @param {Object} data The data of selected vehicle type
 * @returns {{data: *, type: string}} Redux Action
 */
export function select(data) {
  return {
    type: ActionTypes.VEHICLE_TYPE_SELECT,
    data,
  };
}

/**
 * Create new vehicle type
 * @param {Object} data Data for creating vehicle type
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function create(data, token, successCallback, failCallback) {
  return (dispatch) => {
    vehicletypeAPIHelper.create(
      data,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.VEHICLE_TYPE_SELECT,
          data: null,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

/**
 * Update existing vehicle type
 * @param {String} id ID of the vehicle type to be updated
 * @param {Object} data Data for updating vehicle type
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function update(id, data, token, successCallback, failCallback) {
  return (dispatch) => {
    vehicletypeAPIHelper.update(
      id,
      data,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.VEHICLE_TYPE_SELECT,
          data: null,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

export function remove(id, token, successCallback, failCallback) {
  return (dispatch) => {
    vehicletypeAPIHelper.remove(
      id,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.VEHICLE_TYPE_SELECT,
          data: null,
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

const VehicleTypeActions = { getList, select, create, update, remove };
export default VehicleTypeActions;
